import React from 'react'
import Left_menu from './Left_menu'
import Header from './Header'
import Create_order_nav from './Create_order_nav'
import axios from 'axios'
import queryString from 'query-string';
import { useNavigate,useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
// import './customer_style.css';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';


import Swal from 'sweetalert2'

import ReactLoading from 'react-loading';
import config from "../../config"
import { useNetworkState } from 'react-use';
import UseProgressTracker from './UseProgressTracker'
import Footer from './Footer'
import UseBulkShipmentTracker from './UseBulkShipmentTracker'

const Create_order = () => {  let navigate = useNavigate()
    const location = useLocation()
    const isOnline = useNetworkState();
    console.log("isONline  === " ,isOnline )
    // console.log("location==>122", location)
     let  parsed = queryString.parse(location.search);
    const { showProgressBar, completedOrders, totalOrders, recordId, status, toggleProgressBar } = UseProgressTracker();

    //  console.log("parsed",parsed);
    const [defaultCountry, setDefaultCountry] = React.useState({country_id:0})
 
    const [selectedOption, setSelectedOption] = React.useState(null);
    // console.log("selectedOption === " , selectedOption)
    const [selectedOption1, setSelectedOption1] = React.useState(null);
    const [modalState , setModalState] = React.useState({show:false})
    const [options, setOptions] = React.useState([]);
    const[addstate , addSetState] = React.useState({receiver_name:"",receiver_email:"",receiver_mobile:"",receiver_address:"",receiver_country: "", receiver_country_code: "", receiver_postal_code: "", receiver_city: "", receiver_state_name:"",receiver_city_id:"" , receiver_state_id:"", mode:"",error:{} });
    const[addstatesender , addSetStatesender] = React.useState({sender_country: "",  sender_country_code: "", sender_postal_code: "",sender_state_name:"", sender_city: "", sender_address_id : "",sender_city_id:"", sender_name:"" , sender_mobile:"" , sender_email:"", sender_address: "",receiver_name:"",receiver_email:"",receiver_mobile:"",receiver_address:"",receiver_country: "", receiver_country_code: "", receiver_postal_code: "", receiver_city: "", receiver_state_name:"", mode:"",error:{} });
    console.log("addstatesender==== " , addstatesender)
    const[domesticmode,setdomesticmodeState] = React.useState({domestic:false})
    const [returnstate, setReturnState] = React.useState({return_name:"",return_city:"",return_country_code:"",return_postal_code:"", return_mobile: "", return_address: "", return_email: "",return_state_name:"" , return_country:""})
    const[checkboxstate,setcheckboxState]=React.useState(true)
    const[internationalmode,setinternationalmodeState] = React.useState({international:false})
    const[addressState, setaddressState] = React.useState([]);
    const[selected,setSelected ] = React.useState(null)
    const [errorState, setErrorState] = React.useState({receiver_mobile:"" , receiver_email:"" })
    const [countryList, setcountryList] = React.useState([]);
    const [stateList, setStateList] = React.useState([]);
    const [cityList, setCityList] = React.useState([]);
    const [pincodeList, setPincodeList] = React.useState([]);
    const[country,setCountry] = React.useState({country_id:""})
    const[state,setState] = React.useState({state_id:""})
    const[city,setCity] = React.useState({city_id:""})
    const [pincode, setPincode] = React.useState('');
  const [newstate, setnewState] = React.useState('');
  const [newcity, setnewCity] = React.useState('');
  const [newstateid, setnewStateid] = React.useState('');
  const [newcityid, setnewCityid] = React.useState('');
  const [totalValue, setTotalValue] = React.useState(0);
  const [orderNumber, setOrderNumber] = React.useState('');
  const[codlimit , setcodlimit]=React.useState({limit:0})
  const[parceltype,setparceltypeState] = React.useState({parcel:true})
  const[documenttype,setdocumenttypeState] = React.useState({document:false})
  const[statetype,setStatetype] =React. useState({  parcel_type:"Parcel" , order_date : "" , order_number:"" })

  // console.log("state==== " , state)
  const [rowstate, setRowState] = React.useState([{ weight: "", height: "", width: "", length: "", buttonType: "add",error:{} }])
  const [shipstate, setShipstate] = React.useState([{shipment_content:"",total_value:"",quantity:"" ,sku:"",buttonType: "add", error:{}}])
  // console.log("shipstate ==== " , shipstate)
  const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})
  const[paymentmode,setpaymentmode]= React.useState({mode:1})
  // console.log("paymentmode",paymentmode)
  const [codvalue,setcodvalue] = React.useState({cod_amount:0 , err:{}})
  // console.log("codvalue",codvalue)
  const [insurancestate, setinsurance] = React.useState({ insurance: 0 })
  const[dimestate , setdimstate]= React.useState({height:"" , width:"" , length:""})
  // console.log("dimestate === " , dimestate)
  const[deadstate , setdeadstate] = React.useState({dead_weight:"" , vol_weight:"" , total_weight:""})
  // console.log("deadstate ==== " , deadstate)
  const[volume, setVolume] = React.useState()
  const [error, setError] = React.useState('');
  const[errorHeight,setHeightError] = React.useState('');
  const[errorWidth,setWidthError] = React.useState('');
  const[errorLength,setLengthError] = React.useState('');
  const[volstate , setVolstate] = React.useState(null)
  const [addbutton, setaddbutton] = React.useState(false)
  const[carriertype,setcarriertype]= React.useState({type:1})
  const [numberOfBoxes, setNumberOfBoxes] = React.useState(1);
    const [numberOfInvoices, setNumberOfInvoices] = React.useState(1);
    const [boxErrors, setBoxErrors] = React.useState([]);
    const [invoiceErrors, setInvoiceErrors] = React.useState([]);
    const[riskstate,setriskstate]= React.useState({risk:2})
      const[boxstate,setBoxState] = React.useState([])
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
    const{showorderBar, completedOrdersbulk, totalOrdersbulk, logidstate, statusstateorder, toggleProgressBarbulk}= UseBulkShipmentTracker();
    const [boxDetails, setBoxDetails] = React.useState([{
      box_name: '',
      box_length: '',
      box_width: '',
      box_height: '',
      box_weight: '',
      quantity: "", // Add quantity field
      unit_price: "",
      product_name:""
    }]);
    // console.log("boxDetails = =" , boxDetails)

    const [invoiceDetails, setinvoiceDetails] = React.useState([{
      invoice_number: '',
      invoice_date: '',
      invoice_amount: '',
      invoice_ebn: '',
     
    
    }]);
    const handleNumberOfBoxesChange = (event) => {
      const value = parseInt(event.target.value);
      setNumberOfBoxes(value);
      setBoxDetails(Array.from({ length: value }, () => ({
          box_name: '',
          box_length: '',
          box_width: '',
          box_height: '',
          box_weight: '',
          quantity: "", // Add quantity field
          unit_price: "",
          product_name:""
      })));
  };

   
    const handleNumberOfInvoicesChange = (event) => {
        setNumberOfInvoices(parseInt(event.target.value));
        setinvoiceDetails(Array.from({ length: parseInt(event.target.value) }, () => ({
          invoice_number: '',
          invoice_date: '',
          invoice_amount: '',
          invoice_ebn: '',
         
        })));
      };
    React.useEffect(()=>{
       
        getCountryList()
        list()
        customer_boxes()
        generateOrderNumber()
        address_book_detail()
        if(parsed.order_id && parsed.order_date && parsed.shipment_type  ){
            console.log("setting state === ")
            setStatetype({...statetype , parcel_type:parsed.shipment_type , order_number:parsed.order_id , order_date:parsed.order_date})
            if(parsed.shipment_type=="Document"){
              setdocumenttypeState({document:true})
              setparceltypeState({parcel:false})
      
            }
            else{
              setparceltypeState({parcel:true})
              setdocumenttypeState({document:false})
      
            }
            if(parsed.payment_mode){
            if(parsed.payment_mode=="prepaid"){
              setpaymentmode({mode:1})
            }
            else{
              setpaymentmode({mode:2})
              setcodvalue({...codvalue,cod_amount:parsed.cod_amount , err:{}})
            }
          }
          else{
            setpaymentmode({mode:1})
          }
      
            if(parsed.items){
              // console.log("items===")
              if( parsed.items.length>0){
              let parsedItems = JSON.parse(parsed.items)
              // console.log("parsedItems === " , parsedItems)
              const newShipstate = parsedItems.map((item, index) => ({
                shipment_content: item.item_name,
                total_value: item.item_value,
                quantity: item.item_quantity,
                sku:item.item_sku,
                buttonType: index === 0 ? "add" : "minus",
                error: {}
              }));
              setShipstate(newShipstate);
            }
            }
          }
          if(parsed.weight !="" && parsed.height!="" && parsed.width!="" && parsed.length!="" && parsed.volumetric_weight!="" ){
            setdimstate({...dimestate , height:parsed.height , width:parsed.width , length:parsed.length})
            setdeadstate({...deadstate , dead_weight:parsed.dead_weight , vol_weight:parsed.volumetric_weight , total_weight:parsed.weight})
          }
      },[])
 
      React.useEffect(() => {
        if (parsed.receiver_postal_code && parsed.receiver_postal_code.length >= 3) {
          // Fetch details based on the pincode from the URL
          handlePincodeChange({ target: { value: parsed.receiver_postal_code } });
        }
      }, [parsed.receiver_postal_code , country.country_id]);

      
      
 
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
   
    
      // const onChangeLocationstate = (e) => {
      //   // console.log("e general name ",e.target.name);
      //   //  console.log("e general value ",e.target.value);
         
         
      //  let values =   Object.assign({},e.target.value.split(',') )
      // //  console.log("first",values[0])
      //  setState({state_id:values[0]})
      //   addSetState({...addstate , receiver_state_name:values[2], receiver_state_id:values[0], receiver_city:"" , receiver_postal_code:""})
      //   setSelectedOption(null)
      //   setOptions([])
      //   setCityList([])
      //    getCityList({state_id:values[0], country_id:values[1]})
       
      // }
      // const onChangeLocationcity = (e) => {
      //   // console.log("e general name ",e.target.name);
      //   //  console.log("e general value ",e.target.value);
      //    let values =   Object.assign({},e.target.value.split(',') )
 
      //   setCity({city_id:values[0]})
      //   addSetState({...addstate , receiver_city:values[1], receiver_city_id:values[0], receiver_postal_code:""})
      //    getPincodeList(values[0])
      //    setSelectedOption(null)
      
       
      // }
 
      const fetchDetailsFromPincode = async (enteredPincode) => {
        try {
          // Replace 'your-api-endpoint' with the actual endpoint of your backend
          const url = config.apiUrl + '/country/automate_pincode';
          
          // Assuming your API expects a POST request with the entered pincode
          const sendData = { enteredPincode , country_id: country.country_id};
          console.log("sendData == " , sendData)
      
          const response = await axios.post(url, sendData);
      
          // Assuming your API returns an object with state and city properties
          const { state, city , state_id , city_id } = response.data;
      
          return { state, city , state_id , city_id };
        } catch (error) {
          console.error('Error fetching details:', error);
          return {
            state: '',
            city: '',
            state_id:'',
            city_id:'',
          };
        }
      };
      const handlePincodeChange = async (e) => {
        const newPincode = e.target.value;
    
        // Update pincode state
        setPincode(newPincode);
    
        // Check if the length is at least three characters
        if (newPincode.length >= 3) {
          // Fetch details based on the pincode
          const { state: newState, city: newCity , state_id: newStateid , city_id:newCityid } = await fetchDetailsFromPincode(newPincode);
    
          // Update state and city inputs
          setnewState(newState);
          setnewCity(newCity);
          setnewStateid(newStateid);
          setnewCityid(newCityid);
        } else {
          // Reset state and city if the pincode is less than three characters
          setnewState('');
          setnewCity('');
        }
      };
      const getCountryList = () => {
 
 
        let url = config.apiUrl + '/country/country_list';
        let sendData = {limit:300 , status:1};
        // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            // console.log("res ", res);           
            setcountryList(res.data.output)
    
    
        }).catch((e) => {
    
    
        });
    }
    const getStateList = (country_id) => {
 
 
        let url = config.apiUrl + '/country/state_list';
        let sendData = { t_country_id: country_id, limit: 1000 };
        //  console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            //  console.log("state ", res);           
            setStateList(res.data.output)
    
    
        }).catch((e) => {
    
    
        });
    }
   
       const getPincodeList = async (value) => {
        try {
          // console.log("value", value);
          let url = config.apiUrl + '/country/pincode_list';
          let sendData = { city_id: value };
          // console.log("bb", sendData);
          
          const response = await axios.post(url, sendData, { headers: config.headers });
          
          setPincodeList(response.data.output);
          let data = response.data.output;
          const transformedOptions = data.map(item => ({
            value: item.postal_code,
            label: item.postal_code
          }));
          // console.log("transformedOptions == ", transformedOptions);
          setOptions(transformedOptions);
          const matchedOption = transformedOptions.find(option => option.value === parsed.receiver_postal_code);
          // console.log("matchedOption",matchedOption)
          if (matchedOption) {
            setSelectedOption(matchedOption);
          }
          
       
        } catch (error) {
          // console.error(error);
          throw error; 
        }
      };
      
      
      
      const getCityList = (value) => {
      
      //  console.log("value",value)
       let url = config.apiUrl + '/country/city_list';
          let sendData = { state_id: value.state_id,country_id:value.country_id, limit: 1000 };
          // console.log("bb", sendData);
          axios.post(url, sendData, { headers: config.headers }).then((res) => {
              // console.log("city  ", res);           
              setCityList(res.data.output)
      
      
          }).catch((e) => {
      
      
          });
      }
 
      const list = async()=>{
        if(parsed.value==0){
        let url = config.apiUrl + '/country/country_list';
        let senddata = {}
        const responseJson = await axios.post(url, senddata, { headers: config.headers });
            //  console.log("responseJson => ", responseJson.data.defaultCountry);
       
            setDefaultCountry(responseJson.data.defaultCountry)
            addSetState({...addstate, receiver_country:responseJson.data.defaultCountryName , receiver_country_code:responseJson.data.defaultCountrycode ,  receiver_name:parsed.receiver_name?parsed.receiver_name:"" , receiver_mobile:parsed.receiver_mobile?parsed.receiver_mobile:"" , receiver_email:parsed.receiver_email?parsed.receiver_email:"" , receiver_address:parsed.receiver_address?parsed.receiver_address:"" , receiver_state_name:parsed.receiver_state_name?parsed.receiver_state_name:"" , receiver_city:parsed.receiver_city?parsed.receiver_city:"" , receiver_postal_code: parsed.receiver_postal_code?parsed.receiver_postal_code:"" ,receiver_city_id:parsed.receiver_city_id?parsed.receiver_city_id:"" , receiver_state_id:parsed.receiver_state_id?parsed.receiver_state_id:"" ,  mode:parsed.mode?parsed.mode:"Domestic" })
            // setSelectedOption(parsed.receiver_postal_code?parsed.receiver_postal_code:null)
          
            setStateList([])
            setCityList([])
    
            // setOptions([])
             setCountry({country_id:responseJson.data.defaultCountry})
           //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
               getStateList(responseJson.data.defaultCountry)
 
               if(parsed.receiver_state_id!=undefined && parsed.receiver_state_id!=""){
                getCityList({state_id:parsed.receiver_state_id, country_id:responseJson.data.defaultCountry})
                if(parsed.receiver_city_id!=undefined && parsed.receiver_city_id!=""){
                 let pincode = await getPincodeList(parsed.receiver_city_id) 
 //  console.log("pincode == " , pincode)
                  // if(pincode==true){
                  // if(parsed.receiver_postal_code!=undefined && parsed.receiver_postal_code!=""){
                  //   console.log("options-=----" , options)
                  //   const matchedOption = options.find(option => option.value === parsed.receiver_postal_code);
                  //   console.log("matchedOption",matchedOption)
                  //   if (matchedOption) {
                  //     setSelectedOption(matchedOption);
                  //   }
                  //     // selectOptionByPincode(parsed.receiver_postal_code)
                    
                   
               
                  //  }
                  // }
               }
              
              }
       
         
        }
        else{
            setdomesticmodeState({...domesticmode,domestic:false})
            setinternationalmodeState({...internationalmode,international:true})
             addSetState({...addstate,mode:"International" , receiver_country:"" , receiver_country_code:"" , receiver_city:"" , receiver_postal_code:"" , receiver_state_name:""})
             setSelectedOption(null)
             setOptions([])
           
             setCountry({country_id:""})
             setCityList([])
           //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
          setStateList([])
        }
      }
      // const selectOptionByPincode = (pincode) => {
      
      // };
      const handleChange=(e)=>{
        // console.log("namess",e.target.name)
        // console.log("value",e.target.value)
        
        let names = e.target.name
        let value= e.target.value
 
       
       
        if(e.target.type=="text"){
            addSetState({...addstate,[e.target.name]:value})
        }
        else if(e.target.type=="radio"){
            if(e.target.checked==true){
                if(e.target.name=="mode_domestic"){
                    setdomesticmodeState({...domesticmode,domestic:true})
                    setinternationalmodeState({...internationalmode,international:false})
                    //  addSetState({...addstate,mode:"Domestic"})
                         let url = config.apiUrl + '/country/country_list';
                         let senddata = {}
                         axios.post(url, senddata, { headers: config.headers })
                           .then((responseJson) => {
                              // console.log("responseJson => ", responseJson.data.defaultCountry);
                        
                             setDefaultCountry(responseJson.data.defaultCountry)
                             addSetState({...addstate ,mode:"Domestic", receiver_country:responseJson.data.defaultCountryName , receiver_country_code:responseJson.data.defaultCountrycode , receiver_city:"" , receiver_state_name:"" , receiver_postal_code:""})
                             setStateList([])
                             setCityList([])
                             setSelectedOption(null)
                             setOptions([])
                              setCountry({country_id:responseJson.data.defaultCountry})
                            //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
                                getStateList(responseJson.data.defaultCountry)
                        
                           })
                           .catch((error) => {
                             
                            //  console.error(error);
                           });
                       
 
                }
                else if(e.target.name=="mode_international"){
                    setdomesticmodeState({...domesticmode,domestic:false})
                    setinternationalmodeState({...internationalmode,international:true})
                     addSetState({...addstate,mode:"International" , receiver_country:"" , receiver_country_code:"" , receiver_city:"" , receiver_postal_code:"" , receiver_state_name:""})
                     setSelectedOption(null)
                     setOptions([])
                   
                     setCountry({country_id:""})
                     setCityList([])
                   //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
                  setStateList([])
                }
              
            }
        }
        else if(e.target.type=="number"){
            var re = new RegExp("^.{10}$");
            // console.log(value,"   regex number check =   ",re.test(value))
            setErrorState({ ...errorState, receiver_mobile: "" })
            if (re.test(value)) {
              re = new RegExp("^[0-9]+$");
              if (!re.test(value)) {
                setErrorState({ ...errorState, receiver_mobile: "Please enter valid number" })
                //console.log("please enter valid number")
              }
            } else {
              setErrorState({ ...errorState, receiver_mobile: "Please enter 10 digit number " })
             // return(null)
              //console.log("please check length")
            }
            addSetState({...addstate,[e.target.name]:value})
        }
        else if(e.target.type=="email"){
            setErrorState({ ...errorState, receiver_email: "" })
            addSetState({...addstate , receiver_email:e.target.value})
        }
       
       
       
    }
    // const onChangeLocationpincode =(e)=>{
    //     addSetState({...addstate,receiver_postal_code:e.target.value})
    // }
    // const handleSelectChange = selectedOption => {
    //   // console.log("selectedOption ......++++" , selectedOption)
    //     setSelectedOption(selectedOption);
    //      addSetState({...addstate, receiver_postal_code:selectedOption})
    //   };
    
      
    // const next_step=()=>{
    //   let cleanedReceiverAddress = addstate.receiver_address;
 
    //   // Check if '#' exists in receiver_address, then remove it
    //   if (cleanedReceiverAddress.includes('#')) {
    //     cleanedReceiverAddress = cleanedReceiverAddress.replace(/#/g, '');
    //   }
    //     let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 
    //     // if ( re.test(addstate.receiver_email) ) {
          
    //          if(addstate.receiver_name!=""){
    //             //  if(addstate.receiver_email!=""){
    //                 if (re.test(addstate.receiver_email!=""?addstate.receiver_email:"abc@gmail.com") ) {
    //                 if(addstate.receiver_mobile!=""){
    //                     if(addstate.receiver_mobile.length==10){
    //                         if(addstate.receiver_address!=""){
    //                  if(addstate.receiver_country!=""){
    //                   if(pincode!=""){
    //                      if(newcity!=""){
    //                         if(newstate!=""){
                               
    //                             navigate({
    //                                 pathname: '/customer/create_order_2',
    //                                 search: `receiver_name=${addstate.receiver_name}&receiver_email=${addstate.receiver_email!=""?addstate.receiver_email:""}&receiver_mobile=${addstate.receiver_mobile}&receiver_address=${cleanedReceiverAddress}&receiver_country=${addstate.receiver_country}&receiver_country_code=${addstate.receiver_country_code}&receiver_postal_code=${pincode}&receiver_city=${newcity}&receiver_state_name=${newstate}&mode=${addstate.mode}&sender_name=${parsed.sender_name?parsed.sender_name:""}&sender_address=${parsed.sender_address?parsed.sender_address:""}&sender_country=${parsed.sender_country?parsed.sender_country:""}&sender_country_code=${parsed.sender_country_code?parsed.sender_country_code:""}&sender_postal_code=${parsed.sender_postal_code?parsed.sender_postal_code:""}&sender_state_name=${parsed.sender_state_name?parsed.sender_state_name:""}&sender_city=${parsed.sender_city?parsed.sender_city:""}&sender_address_id=${parsed.sender_address_id?parsed.sender_address_id:""}&sender_city_id=${parsed.sender_city_id?parsed.sender_city_id:""}&sender_mobile=${parsed.sender_mobile?parsed.sender_mobile:""}&sender_email=${parsed.sender_email?parsed.sender_email:""}&return_name=${parsed.return_name?parsed.return_name:""}&return_email=${parsed.return_email?parsed.return_email:""}&return_mobile=${parsed.return_mobile?parsed.return_mobile:""}&return_address=${parsed.return_address?parsed.return_address:""}&return_country=${parsed.return_country?parsed.return_country:""}&return_country_code=${parsed.return_country_code?parsed.return_country_code:""}&return_postal_code=${parsed.return_postal_code?parsed.return_postal_code:""}&return_city=${parsed.return_city?parsed.return_city:""}&return_state_name=${parsed.return_state_name?parsed.return_state_name:""}&items=${parsed.items?parsed.items:""}&shipment_type=${parsed.shipment_type?parsed.shipment_type:""}&insurance=${parsed.insurance?parsed.insurance:""}&order_id=${parsed.order_id?parsed.order_id:""}&order_date=${parsed.order_date?parsed.order_date:""}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&cod_amount=${parsed.cod_amount?parsed.cod_amount:""}&payment_mode=${parsed.payment_mode?parsed.payment_mode:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_state_id=${newstateid}&receiver_city_id=${newcityid}&carrier_type=${carriertype.type}`
    //                               });
                                 
    //                         }
    //                         else{
    //                             Toast.fire({
    //                                 background:"rgb(231, 91, 75)",
    //                                 type: 'unsuccess',
    //                                 title: "Please Select Receiver Postal Code",
    //                                 color:"white"
    //                               });
    //                         }
    //                      }
    //                      else{
    //                         Toast.fire({
    //                             background:"rgb(231, 91, 75)",
    //                             type: 'unsuccess',
    //                             title: "Please Select Receiver City",
    //                             color:"white"
    //                           });
    //                      }
    //            }
    //            else{
    //             Toast.fire({
    //                 background:"rgb(231, 91, 75)",
    //                 type: 'unsuccess',
    //                 title: "Please Select Receiver State",
    //                 color:"white"
    //               });
    //            }
    //         }
    //         else{
    //             Toast.fire({
    //                 background:"rgb(231, 91, 75)",
    //                 type: 'unsuccess',
    //                 title: "Please Select Receiver Country",
    //                 color:"white"
    //               });
    //         }
    //     }
    //     else{
    //         Toast.fire({
    //             background:"rgb(231, 91, 75)",
    //             type: 'unsuccess',
    //             title: "Please Fill Receiver Address",
    //             color:"white"
    //           });
    //     }
    //     }else{
    //         Toast.fire({
    //             background:"rgb(231, 91, 75)",
    //             type: 'unsuccess',
    //             title: "Receiver Mobile must be 10 digit Number",
    //             color:"white"
    //           });
    //     }
    //     }
    //     else{
    //         Toast.fire({
    //             background:"rgb(231, 91, 75)",
    //             type: 'unsuccess',
    //             title: "Please Fill Receiver Mobile",
    //             color:"white"
    //           });
    //     }
    // }else{
    //     setErrorState({...errorState , receiver_email:"Please Enter Valid Email"})
    //         Toast.fire({
    //             background:"rgb(231, 91, 75)",
    //             type: 'unsuccess',
    //             title: "Please Enter Valid Receiver Email",
    //             color:"white"
    //           });
    // }
    //             //  }
    //             //  else{
    //             //     Toast.fire({
    //             //         background:"rgb(231, 91, 75)",
    //             //         type: 'unsuccess',
    //             //         title: "Please Fill Receiver Email",
    //             //         color:"white"
    //             //       });
    //             //  }
    //          }
    //          else{
    //             Toast.fire({
    //                 background:"rgb(231, 91, 75)",
    //                 type: 'unsuccess',
    //                 title: "Please Fill Receiver Name",
    //                 color:"white"
    //               });
    //          }
          
    //     // }else{
    //     //     setErrorState({...errorState , receiver_email:"Please Enter Valid Email"})
    //     //     Toast.fire({
    //     //         background:"rgb(231, 91, 75)",
    //     //         type: 'unsuccess',
    //     //         title: "Please Enter Valid Receiver Email",
    //     //         color:"white"
    //     //       });
    //     // }
    // }
    // const checkreturnbox=(e)=>{
    //     if(e.target.checked==true){
    //        setcheckboxState(true)
    //     }
    //     else{
    //       setcheckboxState(false)
    //       setReturnState({return_name:"",return_city:addstate.sender_city ,return_country_code:addstate.sender_country_code,return_postal_code:addstate.sender_postal_code , return_mobile: "", return_address: "", return_email: "",return_state_name:addstate.sender_state_name , return_country:addstate.sender_country})
    //     }
    //   }
      // const handleChangereturn=(e)=>{
      //   setReturnState({...returnstate,[e.target.name]:e.target.value})
      // }
      // const onChangeLocationGeneral = (e) => {
      //   // console.log("e general name ",e.target.name);
      //   //  console.log("e general value ",e.target.value);
      //    let values =   Object.assign({},e.target.value.split(',') )
        
      //    setCountry({country_id:values[0]})
      //    addSetState({...addstate , receiver_country:values[1] , receiver_country_code:values[2]  })
      //       getStateList(values[0])
       
      // }

      const address_book_detail = ()=>{

        let url = config.apiUrl + '/country/address_book';
        let sendData = {  customer_id: userData.customer_id };
        // console.log("bb", sendData);
        axios.post(url,sendData ,{headers:config.headers}).then((res)=>{
            if(res.data.status==true){
                // console.log("sasdfdsa")
                let senderInfo = res.data.output
                setaddressState(res.data.output)
              
                if(parsed.sender_address_id!=""){
                  // addSetState({...addstate , sender_name:parsed.sender_name})
                  const matchingSender = senderInfo.findIndex(sender => sender.address_id === parsed.sender_address_id);
                  // console.log("matchingSender === " , matchingSender)
                  setSelected(matchingSender)
                  addSetStatesender({...addstatesender , sender_country:parsed.sender_country , sender_city:parsed.sender_city , sender_state_name: parsed.sender_state_name , sender_postal_code:parsed.sender_postal_code , sender_country_code:parsed.sender_country_code  , sender_address_id : parsed.sender_address_id  , sender_name:parsed.sender_name , sender_mobile:parsed.sender_mobile , sender_email:parsed.sender_email , sender_address: parsed.sender_address , sender_city_id:parsed.sender_city_id})

                  setReturnState({...returnstate,return_name:parsed.return_name, return_mobile:parsed.return_mobile, return_address:parsed.return_address, return_email:parsed.return_email , return_state_name:parsed.return_state_name , return_city:parsed.return_city , return_country:parsed.return_country , return_country_code:parsed.return_country_code , return_postal_code:parsed.return_postal_code })

                
                }
            }

        }).catch(()=>{
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              
              Toast.fire({
                background:"rgb(231, 91, 75)",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color:"white"
              });
       
           
        })
       }

       const selectAddress =(sub)=>{
        console.log("sub == " , sub)
        // let sub = e.target.value
        // setSelected(index)
        addSetStatesender({...addstatesender , sender_country:sub.country_name , sender_city:sub.city_name , sender_state_name: sub.state_name , sender_postal_code:sub.pincode , sender_country_code:sub.country_code  , sender_address_id : sub.address_id  , sender_name:sub.full_name , sender_mobile:sub.mobile , sender_email:sub.email , sender_address: sub.address , sender_city_id:sub.city_id})
        
           setReturnState({...returnstate,return_name:sub.full_name, return_mobile:sub.mobile, return_address:sub.address, return_email:sub.email , return_state_name:sub.state_name , return_city:sub.city_name , return_country:sub.country_name , return_country_code:sub.country_code , return_postal_code:sub.pincode })
           
       
      }
      const handleChangetype=(e)=>{
        // console.log("namess",e.target.name)
        // console.log("value",e.target.value)
       
        let names = e.target.name
        let value= e.target.value
       
        if(e.target.type=="text"){
        setStatetype({...statetype,[e.target.name]:value})
        }
        else if(e.target.type=="radio"){
            if(e.target.checked==true){
              
                 if(e.target.name=="document"){
                  setparceltypeState({...parceltype,parcel:false})
                  setdocumenttypeState({...documenttype,document:true})
                  setStatetype({...statetype,parcel_type:"Document"})
                }
                else{
                  setparceltypeState({...parceltype,parcel:true})
                  setdocumenttypeState({...documenttype,document:false})
                  setStatetype({...statetype,parcel_type:"Parcel"})
                }
            }
        }
        else if(e.target.type=="number"){
          setStatetype({...statetype,[e.target.name]:value})
        }
        else if(e.target.type=="date"){
            setStatetype({...statetype,[e.target.name]:value})
           
        }
    }
    const payment_mode =(e)=>{
        if(e.target.name=="prepaid"){
          setpaymentmode({mode:1})
        }
        else{
          setpaymentmode({mode:2})
        }
      }
      
      const codvalueChange=(e)=>{
          
        setcodvalue({...codvalue,cod_amount:e.target.value , err:{}})
      }

      const handleChange3 = (e, index) => {
        //  console.log("eee",e.target.value.length)
        let items = [...shipstate];
        let names = e.target.name;
        let value = e.target.value;
        if(e.target.type=="number"){
        if(value > 0 ) {
          items[index].error[names] = false;
        }else{
          items[index].error[names] = true;
        }
    }
    else{
        if(value.length > 0 ) {
            items[index].error[names] = false;
          }else{
            items[index].error[names] = true;
          }
    }
       // console.log(items[index][names])
        items[index][names] = value;
        setShipstate(items)
        //setState({ ...state, [names]: value })
      }
      function addRows(type, index) {
        // console.log("type    ", type, " . ", index)
        let items = [...rowstate];
        let ship_items = [...shipstate];
        // console.log("items    ", items)
        if (type == 1) {
          let newItem = { weight: "", height: "", width: "", length: "", buttonType: "remove",error:{} };
          // console.log("newItem  =========>   ", newItem)
          let newShipItem = {shipment_content:"",total_value:"",quantity:"" ,sku:"",buttonType: "remove", error:{}};
    
          items.push(newItem);
          ship_items.push(newShipItem);
        
          // console.log("items  =========>   ", items)
    
          setRowState(items)
          setShipstate(ship_items)
        } else if (type == 2) {
          items.splice(index, 1);
          ship_items.splice(index,1)
          setRowState(items)
          setShipstate(ship_items)
        }
      }

      React.useEffect(() => {
        calculateTotalValue();
      }, [shipstate]);
      
      const calculateTotalValue = () => {
        const total = shipstate.reduce((acc, item) => acc + parseFloat(item.total_value || 0), 0);
        setTotalValue(total.toFixed(2)); // You can format the total as needed.
      };

      const generateOrderNumber = () => {
        // Generate the order number logic
        const randomNumber = Math.floor(Math.random() * 1000000);
        const formattedOrderNumber =  + randomNumber;
    
        setOrderNumber(formattedOrderNumber);
        const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
         let order_date = `${year}-${month}-${day}`;
        setStatetype({...statetype , order_number:formattedOrderNumber ,order_date:order_date })
      }

      const handleWeightChange = (e) => {
        setError('')
        
        setdeadstate({...deadstate , [e.target.name]:e.target.value})
       
      };

      const handleInputChange =(e)=>{
        setWidthError('')
        setLengthError('')
        setHeightError('')
    
         let values = e.target.value 
         setdimstate({...dimestate , [e.target.name]:values})
      }

      React.useEffect(() => {
        if ( dimestate.height && dimestate.width  && dimestate.length ) {
            let divisor =  5000 ;
            const calculatedVolume = ( dimestate.height * dimestate.width * dimestate.length) / divisor;
            setVolume(calculatedVolume.toFixed(2));
        } else {
            setVolume(0);
        }
    }, [ dimestate.height, dimestate.width, dimestate.length, volstate]);

    const orderCreate = () => {
console.log("carriertype == " , carriertype.type)

        setaddbutton(true)

        if(carriertype.type==1){
        
        // console.log("order_id")
        let cleanedReceiverAddress = addstate.receiver_address;

        // Check if '#' exists in receiver_address, then remove it
        if (cleanedReceiverAddress.includes('#')) {
          cleanedReceiverAddress = cleanedReceiverAddress.replace(/#/g, '');
        }
          let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   
          // if ( re.test(addstate.receiver_email) ) {
            
               if(addstate.receiver_name!=""){
                  //  if(addstate.receiver_email!=""){
                      if (re.test(addstate.receiver_email!=""?addstate.receiver_email:"abc@gmail.com") ) {
                      if(addstate.receiver_mobile!=""){
                          if(addstate.receiver_mobile.length==10){
                              if(addstate.receiver_address!=""){
                       if(addstate.receiver_country!=""){
                        if(pincode!=""){
                           if(newcity!=""){
                              if(newstate!=""){
                                if(addstatesender.sender_name!=undefined && addstatesender.sender_name!="" && addstatesender.sender_address!=undefined && addstatesender.sender_address!=""){  
                                    let ship_items = [...shipstate];
                                    let fl = true;
                                    ship_items.map((val)=>{
                                     // console.log("val=> ",val);
                                     val.error = {};
                                      if(val.total_value == "") {
                                        val.error["total_value"] = true;     
                                        fl = false;   
                                      }
                                      if(val.shipment_content == "") {
                                        val.error["shipment_content"] = true;     
                                        fl = false;     
                                      }
                                      if(val.quantity == "") {
                                        val.error["quantity"] = true;    
                                        fl = false;      
                                      }
                                    
                                      // console.log("val=> ",val);
                                    })
                                    setShipstate(ship_items)
                                    if(statetype.parcel_type!=""){
                                        if ( fl ) {
                                           if(paymentmode.mode==1 || paymentmode.mode==2 && codvalue.cod_amount!="" ){

        if(deadstate.dead_weight!=""){
        if (dimestate.height!="" ) {
           if(dimestate.width!="" ){
           if(dimestate.length!="" ){
            
            let dataToSend = { sender_name: addstatesender.sender_name,
                                sender_mobile: addstatesender.sender_mobile,
                                sender_email: addstatesender.sender_email,
                                sender_address: addstatesender.sender_address,
                                sender_city: addstatesender.sender_city,
                                sender_city_id: addstatesender.sender_city_id,
                                sender_country_name: addstatesender.sender_country,
                                sender_country_code: addstatesender.sender_country_code,
                                sender_postal_code: addstatesender.sender_postal_code,
                                receiver_name: addstate.receiver_name,
                                receiver_mobile: addstate.receiver_mobile,
                                receiver_email: addstate.receiver_email!=""?addstate.receiver_email:"",
                                receiver_address: cleanedReceiverAddress,
                                receiver_city: newcity,
                                receiver_country_name: addstate.receiver_country,
                                receiver_country_code: addstate.receiver_country_code,
                                receiver_postal_code: pincode,
                                receiver_city_id:newcityid ,
                                receiver_state_id: newstateid,
                                sender_state_name:addstatesender.sender_state_name,
                                receiver_state_name:newstate,
                                return_name: returnstate.return_name,
                                return_mobile: returnstate.return_mobile,
                                return_email: returnstate.return_email,
                                return_address: returnstate.return_address,
                                return_city: returnstate.return_city,
                                return_state_name: returnstate.return_state_name,
                                return_country_name: returnstate.return_country,
                                return_country_code: returnstate.return_country_code,
                                return_postal_code: returnstate.return_postal_code,
                                payment_mode: paymentmode.mode==1?"prepaid":"cod",
                                shipment_type: statetype.parcel_type,
                                cod_amount : codvalue.cod_amount,
                                volumetric_weight: volume,
                                total_weight: volume && deadstate.dead_weight!=""?parseFloat(volume)>parseFloat(deadstate.dead_weight)?volume:deadstate.dead_weight:0.00,
                                dead_weight: deadstate.dead_weight, length: dimestate.length, height: dimestate.height,
                                width: dimestate.width, item_name:"",item_value:"",
                                insurance_amount: insurancestate.insurance,
                                type: statetype.parcel_type,
                                address_id : addstatesender.sender_address_id,
                                order_id: statetype.order_number,
                                order_date: statetype.order_date,
                                mode:"Domestic",
                                carrier_type:1,
                                }
                  
                                dataToSend.item_name = shipstate.map((sub)=>(
                                sub.shipment_content
                                ))   
                                dataToSend.item_value = shipstate.map((sub)=>(
    
                                sub.total_value
                                ))      
                                dataToSend.quantity = shipstate.map((sub)=>(
    
                                sub.quantity
                                ))
                                
                                dataToSend.sku = shipstate.map((sub)=>(
    
                                  sub.sku
                                  ))
                                
                                dataToSend.customer_id = userData.customer_id;
                                // console.log("datatoSend", dataToSend)
    
                                let url = config.apiUrl + '/shipment/order_create';
    
                                // setOtherState({ ...otherState, submit_button: false })
                                axios.post(url, dataToSend, { headers: config.headers })
                                .then((responseJson) => {
                                // console.log("responseJson => ", responseJson.data.output);
                                // setOtherState({ ...otherState, submit_button: true })
                                if (responseJson.data.status == true) {
                                    navigate({pathname:`/customer/orders`,
                                   
                                  })   
                                  const Toast = Swal.mixin({
                                    toast: true,
                                    position: 'bottom-end',
                                    showConfirmButton: false,
                                    timer: 3000
                                  })       
                                Toast.fire({
                                background:"rgb(25, 135, 84)",
                                type: 'unsuccess',
                                title: "Order created successfully.",
                                color:"white"
                                });
        setaddbutton(false)
    
    
                                }
                                else{
                                    const Toast = Swal.mixin({
                                        toast: true,
                                        position: 'bottom-end',
                                        showConfirmButton: false,
                                        timer: 3000
                                      })       
                                    Toast.fire({
                                    background:"rgb(25, 135, 84)",
                                    type: 'unsuccess',
                                    title: "Something Went Wrong.",
                                    color:"white"
                                    }); 
        setaddbutton(false)
    
                                }
                                })
             
         
           
                            }else{
                                setLengthError('Length is Required')
        setaddbutton(false)
    
                            }
           }
           else{
            setWidthError('Width is Required');
        setaddbutton(false)
    
           }
       
          
     
        }
        else{
            setHeightError('Height is Required'); 
        setaddbutton(false)
    
        }
    }else{
        setError('Weight is Required'); 
        setaddbutton(false)
    }
                         } else{
                            const Toast = Swal.mixin({
                              toast: true,
                              position: 'bottom-end',
                              showConfirmButton: false,
                              timer: 3000
                            })
                            
                            Toast.fire({
                              background:"rgb(231, 91, 75)",
                              type: 'unsuccess',
                              title: "Please enter cod value",
                              color:"white"
                            });
        setaddbutton(false)

                           }     }  else{
                                const Toast = Swal.mixin({
                                  toast: true,
                                  position: 'bottom-end',
                                  showConfirmButton: false,
                                  timer: 3000
                                })
                                
                                Toast.fire({
                                  background:"rgb(231, 91, 75)",
                                  type: 'unsuccess',
                                  title: "Please fill all the Details",
                                  color:"white"
                                });
        setaddbutton(false)

                                // console.log("----error:   ");      
                              }    } else{
                                    const Toast = Swal.mixin({
                                        toast: true,
                                        position: 'bottom-end',
                                        showConfirmButton: false,
                                        timer: 3000
                                      })
                                      
                                      Toast.fire({
                                        background:"rgb(231, 91, 75)",
                                        type: 'unsuccess',
                                        title: "Please Select Shipment Type",
                                        color:"white"
                                      });
        setaddbutton(false)

                                      // console.log("----error:   "); 
                                }  }
                              else{
                                Toast.fire({
                                    background:"rgb(231, 91, 75)",
                                    type: 'unsuccess',
                                    title: "Please Select Sender Detail",
                                    color:"white"
                                  });
        setaddbutton(false)

                               }
}
else{
    Toast.fire({
        background:"rgb(231, 91, 75)",
        type: 'unsuccess',
        title: "Please Select Receiver State",
        color:"white"
      });
      setaddbutton(false)
}

}
else{
Toast.fire({
    background:"rgb(231, 91, 75)",
    type: 'unsuccess',
    title: "Please Select Receiver City",
    color:"white"
  });
  setaddbutton(false)
}
}
else{
Toast.fire({
background:"rgb(231, 91, 75)",
type: 'unsuccess',
title: "Please Select Receiver Pincode",
color:"white"
});
setaddbutton(false)
}
}
else{
Toast.fire({
background:"rgb(231, 91, 75)",
type: 'unsuccess',
title: "Please Select Receiver Country",
color:"white"
});
setaddbutton(false)
}

}
else{
Toast.fire({
background:"rgb(231, 91, 75)",
type: 'unsuccess',
title: "Please Fill Receiver Address",
color:"white"
});
setaddbutton(false)
}
}else{
Toast.fire({
background:"rgb(231, 91, 75)",
type: 'unsuccess',
title: "Receiver Mobile must be 10 digit Number",
color:"white"
});
setaddbutton(false)
}
}
else{
Toast.fire({
background:"rgb(231, 91, 75)",
type: 'unsuccess',
title: "Please Fill Receiver Mobile",
color:"white"
});
setaddbutton(false)
}
}else{
setErrorState({...errorState , receiver_email:"Please Enter Valid Email"})
Toast.fire({
background:"rgb(231, 91, 75)",
type: 'unsuccess',
title: "Please Enter Valid Receiver Email",
color:"white"
});
setaddbutton(false)
}

}
            else{
            Toast.fire({
            background:"rgb(231, 91, 75)",
            type: 'unsuccess',
            title: "Please Fill Receiver Name",
            color:"white"
            });
            setaddbutton(false)
            }

          }
          else{

         
            let cleanedReceiverAddress = addstate.receiver_address;

            // Check if '#' exists in receiver_address, then remove it
            if (cleanedReceiverAddress.includes('#')) {
              cleanedReceiverAddress = cleanedReceiverAddress.replace(/#/g, '');
            }
              let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
       
              // if ( re.test(addstate.receiver_email) ) {
                
                   if(addstate.receiver_name!=""){
                      //  if(addstate.receiver_email!=""){
                          if (re.test(addstate.receiver_email!=""?addstate.receiver_email:"abc@gmail.com") ) {
                          if(addstate.receiver_mobile!=""){
                              if(addstate.receiver_mobile.length==10){
                                  if(addstate.receiver_address!=""){
                           if(addstate.receiver_country!=""){
                            if(pincode!=""){
                               if(newcity!=""){
                                  if(newstate!=""){
                                    if(addstatesender.sender_name!=undefined && addstatesender.sender_name!="" && addstatesender.sender_address!=undefined && addstatesender.sender_address!=""){  
                                        if(statetype.parcel_type!=""){
                                            if(paymentmode.mode==1 || paymentmode.mode==2 && codvalue.cod_amount!="" ){
    
            if(deadstate.dead_weight!=""){
            if (dimestate.height!="" ) {
               if(dimestate.width!="" ){
               if(dimestate.length!="" ){
                const newBoxErrors = [];
                boxDetails.forEach((box, index) => {
                  const errors = {};
                  // if (!box.box_name) errors.box_name = 'Box name is required';
                  if (!box.box_length) errors.box_length = 'Length is required';
                  if (!box.box_width) errors.box_width = 'Width is required';
                  if (!box.box_height) errors.box_height = 'Height is required';
                  if (!box.box_weight) errors.box_weight = 'Weight is required';
                  if (!box.quantity) errors.quantity = 'Quantity is required';
                  if (!box.product_name) errors.product_name = 'Product Name is required';
                  if (!box.unit_price) errors.unit_price = 'Unit price is required';
        
        
                  // Add validations for other box fields
                  newBoxErrors[index] = errors;
                });
                setBoxErrors(newBoxErrors);
            
                const newInvoiceErrors = [];
                invoiceDetails.forEach((invoice, index) => {
                  const errors = {};
                  if (!invoice.invoice_number) errors.invoice_number = 'Invoice number is required';
                  if (!invoice.invoice_date) errors.invoice_date = 'Invoice Date is required';
                  if (!invoice.invoice_amount) errors.invoice_amount = 'Invoice Amount is required';
        
                  // Validate EBN number if invoice amount is greater than 50000
                  if (invoice.invoice_amount > 50000 && !invoice.invoice_ebn) {
                    errors.invoice_ebn = 'EBN number is required for invoice amount greater than 50000';
                  }
                  // Add validations for other invoice fields
                  newInvoiceErrors[index] = errors;
                });
                setInvoiceErrors(newInvoiceErrors);
                if (newBoxErrors.some(errors => Object.keys(errors).length > 0)){
                  setaddbutton(false)
                  const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                  })
                  
                  Toast.fire({
                    background:"rgb(231, 91, 75)",
                    type: 'unsuccess',
                    title: "Please fill Box details",
                    color:"white"
                  });
                  return; 
                }  
            if(newInvoiceErrors.some(errors => Object.keys(errors).length > 0)) {
              setaddbutton(false)
              const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              
              Toast.fire({
                background:"rgb(231, 91, 75)",
                type: 'unsuccess',
                title: "Please fill Invoice details",
                color:"white"
              });
              return; 
           
          }
    
                
                let dataToSend = { sender_name: addstatesender.sender_name,
                                    sender_mobile: addstatesender.sender_mobile,
                                    sender_email: addstatesender.sender_email,
                                    sender_address: addstatesender.sender_address,
                                    sender_city: addstatesender.sender_city,
                                    sender_city_id: addstatesender.sender_city_id,
                                    sender_country_name: addstatesender.sender_country,
                                    sender_country_code: addstatesender.sender_country_code,
                                    sender_postal_code: addstatesender.sender_postal_code,
                                    receiver_name: addstate.receiver_name,
                                    receiver_mobile: addstate.receiver_mobile,
                                    receiver_email: addstate.receiver_email!=""?addstate.receiver_email:"",
                                    receiver_address: cleanedReceiverAddress,
                                    receiver_city: newcity,
                                    receiver_country_name: addstate.receiver_country,
                                    receiver_country_code: addstate.receiver_country_code,
                                    receiver_postal_code: pincode,
                                    receiver_city_id:newcityid ,
                                    receiver_state_id: newstateid,
                                    sender_state_name:addstatesender.sender_state_name,
                                    receiver_state_name:newstate,
                                    return_name: returnstate.return_name,
                                    return_mobile: returnstate.return_mobile,
                                    return_email: returnstate.return_email,
                                    return_address: returnstate.return_address,
                                    return_city: returnstate.return_city,
                                    return_state_name: returnstate.return_state_name,
                                    return_country_name: returnstate.return_country,
                                    return_country_code: returnstate.return_country_code,
                                    return_postal_code: returnstate.return_postal_code,
                                    payment_mode: paymentmode.mode==1?"prepaid":"cod",
                                    shipment_type: statetype.parcel_type,
                                    cod_amount : codvalue.cod_amount,
                                    volumetric_weight: volume,
                                    total_weight: volume && deadstate.dead_weight!=""?parseFloat(volume)>parseFloat(deadstate.dead_weight)?volume:deadstate.dead_weight:0.00,
                                    dead_weight: deadstate.dead_weight, length: dimestate.length, height: dimestate.height,
                                    width: dimestate.width, item_name:"",item_value:"",
                                    insurance_amount: insurancestate.insurance,
                                    type: statetype.parcel_type,
                                    address_id : addstatesender.sender_address_id,
                                    order_id: statetype.order_number,
                                    order_date: statetype.order_date,
                                    mode:"Domestic",
                                    boxes:boxDetails,
                                    invoices:invoiceDetails,
                                    rv_insurance :riskstate.mode==2?true:false,
                                    carrier_type:2,
                                    }
                      
                                      
                                    
                                    dataToSend.customer_id = userData.customer_id;
                                    // console.log("datatoSend", dataToSend)
        
                                    let url = config.apiUrl + '/shipment/order_create';
        
                                    // setOtherState({ ...otherState, submit_button: false })
                                    axios.post(url, dataToSend, { headers: config.headers })
                                    .then((responseJson) => {
                                    // console.log("responseJson => ", responseJson.data.output);
                                    // setOtherState({ ...otherState, submit_button: true })
                                    if (responseJson.data.status == true) {
                                     
                                      navigate({pathname:`/customer/b2b_orders`,})
                                     
                                      const Toast = Swal.mixin({
                                        toast: true,
                                        position: 'bottom-end',
                                        showConfirmButton: false,
                                        timer: 3000
                                      })       
                                    Toast.fire({
                                    background:"rgb(25, 135, 84)",
                                    type: 'unsuccess',
                                    title: "Order created successfully.",
                                    color:"white"
                                    });
            setaddbutton(false)
        
        
                                    }
                                    else{
                                        const Toast = Swal.mixin({
                                            toast: true,
                                            position: 'bottom-end',
                                            showConfirmButton: false,
                                            timer: 3000
                                          })       
                                        Toast.fire({
                                        background:"rgb(25, 135, 84)",
                                        type: 'unsuccess',
                                        title: "Something Went Wrong.",
                                        color:"white"
                                        }); 
            setaddbutton(false)
        
                                    }
                                    })
                 
             
               
                                }else{
                                    setLengthError('Length is Required')
            setaddbutton(false)
        
                                }
               }
               else{
                setWidthError('Width is Required');
            setaddbutton(false)
        
               }
           
              
         
            }
            else{
                setHeightError('Height is Required'); 
            setaddbutton(false)
        
            }
        }else{
            setError('Weight is Required'); 
            setaddbutton(false)
        }
                             } else{
                                const Toast = Swal.mixin({
                                  toast: true,
                                  position: 'bottom-end',
                                  showConfirmButton: false,
                                  timer: 3000
                                })
                                
                                Toast.fire({
                                  background:"rgb(231, 91, 75)",
                                  type: 'unsuccess',
                                  title: "Please enter cod value",
                                  color:"white"
                                });
            setaddbutton(false)
    
                               }  
                                  } else{
                                        const Toast = Swal.mixin({
                                            toast: true,
                                            position: 'bottom-end',
                                            showConfirmButton: false,
                                            timer: 3000
                                          })
                                          
                                          Toast.fire({
                                            background:"rgb(231, 91, 75)",
                                            type: 'unsuccess',
                                            title: "Please Select Shipment Type",
                                            color:"white"
                                          });
            setaddbutton(false)
    
                                          // console.log("----error:   "); 
                                    }  }
                                  else{
                                    Toast.fire({
                                        background:"rgb(231, 91, 75)",
                                        type: 'unsuccess',
                                        title: "Please Select Sender Detail",
                                        color:"white"
                                      });
            setaddbutton(false)
    
                                   }
    }
    else{
        Toast.fire({
            background:"rgb(231, 91, 75)",
            type: 'unsuccess',
            title: "Please Select Receiver State",
            color:"white"
          });
          setaddbutton(false)
    }
    
    }
    else{
    Toast.fire({
        background:"rgb(231, 91, 75)",
        type: 'unsuccess',
        title: "Please Select Receiver City",
        color:"white"
      });
      setaddbutton(false)
    }
    }
    else{
    Toast.fire({
    background:"rgb(231, 91, 75)",
    type: 'unsuccess',
    title: "Please Select Receiver Pincode",
    color:"white"
    });
    setaddbutton(false)
    }
    }
    else{
    Toast.fire({
    background:"rgb(231, 91, 75)",
    type: 'unsuccess',
    title: "Please Select Receiver Country",
    color:"white"
    });
    setaddbutton(false)
    }
    
    }
    else{
    Toast.fire({
    background:"rgb(231, 91, 75)",
    type: 'unsuccess',
    title: "Please Fill Receiver Address",
    color:"white"
    });
    setaddbutton(false)
    }
    }else{
    Toast.fire({
    background:"rgb(231, 91, 75)",
    type: 'unsuccess',
    title: "Receiver Mobile must be 10 digit Number",
    color:"white"
    });
    setaddbutton(false)
    }
    }
    else{
    Toast.fire({
    background:"rgb(231, 91, 75)",
    type: 'unsuccess',
    title: "Please Fill Receiver Mobile",
    color:"white"
    });
    setaddbutton(false)
    }
    }else{
    setErrorState({...errorState , receiver_email:"Please Enter Valid Email"})
    Toast.fire({
    background:"rgb(231, 91, 75)",
    type: 'unsuccess',
    title: "Please Enter Valid Receiver Email",
    color:"white"
    });
    setaddbutton(false)
    }
    
    }
                else{
                Toast.fire({
                background:"rgb(231, 91, 75)",
                type: 'unsuccess',
                title: "Please Fill Receiver Name",
                color:"white"
                });
                setaddbutton(false)
                }
    
          }

    }

    const select_type =(e)=>{
      if(e.target.name=="b2c"){
        setcarriertype({type:1})
      }
      else{
        setcarriertype({type:2})
      }
    }

    const handleBoxChange = (event, index) => {
      const selectedBoxName = event.target.value;
      const selectedBox = boxstate.find(box => box.box_name === selectedBoxName);
    
      if (selectedBox) {
        setBoxDetails(prevState => {
          const newState = [...prevState];
          newState[index].box_name = selectedBoxName;
          newState[index].box_length = selectedBox.box_length;
          newState[index].box_width = selectedBox.box_width;
          newState[index].box_height = selectedBox.box_height;
          newState[index].box_weight = selectedBox.box_weight;
          return newState;
        });
      }
    };
      const handleBoxDimensionChange = (event, key, index) => {

        const value = key === 'quantity' || key === 'unit_price' ? parseFloat(event.target.value) : event.target.value;
        setBoxDetails(prevState => {
          const newState = [...prevState];
          newState[index][key] = value;
          return newState;
        });
      };

      const handleInvoiceDimensionChange = (event, key, index) => {

        const value = key === 'invoice_amount' ? parseFloat(event.target.value) : event.target.value;
        setinvoiceDetails(prevState => {
          const newState = [...prevState];
          newState[index][key] = value;
          return newState;
        });
      };

      const risk_mode =(e)=>{
        if(e.target.name=="owner_risk"){
          setriskstate({risk:1})
        }
        else{
          setriskstate({risk:2})
        }
      }

      const customer_boxes = () => {
       
       
        let full_api = config.apiUrl  + `/user/get_customer_boxes`;
       let sendData = {}
        axios.post(full_api, sendData, {
             headers: config.headers 
        }).then((res) => {
            console.log("res ", res);
           
            if(res.data.status==true){
              setBoxState(res.data.output)
               
             }
             else{
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!',
                    
                  })
                }
            
        }).catch((e) => {
            // Swal.fire({
            //     icon: 'error',
            //     title: 'Oops...',
            //     text: 'Something went wrong!',
                
            //   })
         
          console.log("----error:   ", e);

        });
    }

  return (
    <div>
          {/* <?php include 'meta.php';?> */}
    
    {/* <?php include 'left_menu.php';?> */}
    <Left_menu value={1}/>
 
    <section class="home ">
        {/* <?php include 'header.php';?>  */}
        <Header/>
 
        <Create_order_nav value={1}/>
  
     
       
        


        <section class="mb-3">
          <div class="container-fluid">
          <section class="create_order_adv">
          {/* <div className='col-md-6'>
              <h4 className='pb-3'>Select Type</h4>
              <div class="row ">
                            <div class="col-12 col-md-3 mb-3">
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" name="b2c" id="inlineRadio1" value="option1" onChange={(e) => select_type(e)} checked={carriertype.type==1}/>
                                  <label class="form-check-label" for="inlineRadio1">B2C</label>
                                </div>
                            </div>
                            <div class="col-12 col-md mb-3">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="b2b" id="inlineRadio1" value="option1" onChange={(e) => select_type(e)} checked={carriertype.type==2} />
                                <label class="form-check-label" for="inlineRadio1">B2B</label>
                              </div>
                            </div>
                        </div>

             </div> */}
                <div class="row">
                    <div class="col-12 col-md">
                      <div class="card mb-3">
                        <div class="card-body">
                          <div class="row">
                              <div class="col-12 col-md-3">
                              <h6>Shipping from</h6>
                              </div>
                              <div class="col-12 col-md">
                              <select className="form-select" onChange={(e) => selectAddress(addressState[e.target.value])}>
                          {parsed.address_id==undefined || parsed.address_id==""?      <option>Select</option>:""}
  {addressState.map((sub, index) => (
    <option key={index} value={index} selected={sub.address_id === parsed.sender_address_id? sub.address_id == parsed.sender_address_id:""}>
      {sub.warehouse_id ? sub.warehouse_id : sub.warehouse_name}, {sub.address}, {sub.city_name}, {sub.state_name}, - {sub.pincode}
    </option>
  ))}
</select>
                              </div>
                              <div class="col-12 col-md-1">
                                <a href="/customer/warehouse" className="text-decoration-none"  data-bs-placement="top" aria-label="Direct Sales" data-bs-original-title="Add new warehouse"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="plus" class="lucide lucide-plus"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg></a>
                              </div>
                          </div>
                        </div>
                      </div>
                      <h4 class="pb-1">Add Buyer's Details</h4>
                      <div class="card mb-3">
                        <div class="card-body">
                          <section class="pb-5">
                              <h6 class="">To whom is the order being delivered? <span class="text-muted">(Buyer's Info)</span></h6>
                              <div class="row">
                                  <div class="col-12 col-md-4 mb-3">
                                      <label for="" class="form-label">Mobile Number:</label>
                                      <div class="input-group">
                                          <span class="input-group-text"><i class="fa fa-mobile" aria-hidden="true"></i></span>
                                            <input type="text" class="form-control" placeholder="Enter Buyer's Mobile Number" name="receiver_mobile" onChange={(e)=>handleChange(e)} value={addstate.receiver_mobile}/>
                                      </div>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                      <label for="" class="form-label">Full Name:</label>
                                      <input type="text" class="form-control" id="" placeholder="Enter Full Name" name="receiver_name" onChange={(e)=>handleChange(e)} value={addstate.receiver_name}/>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                      <label for="" class="form-label">Email Id:</label>
                                      <input type="text" class="form-control" id="" placeholder="Enter Email Id" name="receiver_email" onChange={(e)=>handleChange(e)} value={addstate.receiver_email}/>
                               {(errorState.receiver_email != "") ?
                                 <label><span className="text-danger">* {errorState.receiver_email}</span></label> : ""}
                                  </div>
                              </div>
                          </section>

                          <section>
                              <h6 class="">Where is the order being delivered to? <span class="text-muted">(Buyer's Address)</span></h6>
                              <div class="row">
                                  <div class="col-12 col-md-12 mb-3">
                                      <label for="" class="form-label">Complete Address:</label>
                                      <input type="text" class="form-control" id="" placeholder="Enter Complete Address" name="receiver_address" onChange={(e)=>handleChange(e)} value={addstate.receiver_address} />
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                      <label for="" class="form-label">Pincode:</label>
                                      <input  type='text'  className='form-control' placeholder='Enter Pincode' value={pincode}
       onChange={handlePincodeChange}></input>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                      <label for="" class="form-label">State:</label>
                                      <input className='form-control' type='text' disabled='disabled' value={newstate}></input>
                                  </div>
                                  <div class="col-12 col-md-4 mb-3">
                                      <label for="" class="form-label">City:</label>
                                      <input className='form-control' type='text' disabled='disabled' value={newcity}></input>
                                  </div>
                              </div>
                          </section>
                          {/* <div class="py-3">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" checked=""/>
                                <label class="form-check-label" for="inlineCheckbox1">Billing Address is same is Shipping Address</label>
                              </div>
                          </div> */}
                        </div>
                      </div>
                      <h4>Order Details</h4>
                      <div class="card mb-3 ">
                        <div class="card-body">
                      
                    <section class="pb-3">
                            <h6 class="mb-1">Shipment Type</h6>
                            {/* <small class="">Select mode of payment that your buyer has chosen for the order</small> */}
                            <div class="row mt-4">
                                <div class="col-12 col-md-3 mb-3">
                                    <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio"  onChange={(e)=>handleChangetype(e)} name="document" id="inlxineRadio1" value="Document"  checked={documenttype.document==true && parceltype.parcel==false}/>
                                <label class="form-check-label" for="inlineRadio1">Document</label>
                                    </div>
                                </div>
                                <div class="col-12 col-md mb-3">
                                  <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" name="parcel" onChange={(e)=>handleChangetype(e)} id="inlixneRadio2" value="Parcel" checked={parceltype.parcel==true && documenttype.document==false }/>
                                <label class="form-check-label" for="inlineRadio2">Parcel </label>
                                  </div>
                                </div>
                            </div>
                          
                          </section>
                          <section class="pb-3">
                            <h6 class="mb-1">Payment Details</h6>
                            <small class="">Select mode of payment that your buyer has chosen for the order</small>
                            <div class="row mt-4">
                                <div class="col-12 col-md-3 mb-3">
                                    <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="prepaid" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)} checked={paymentmode.mode==1} />
                                  <label class="form-check-label" for="inlineRadio1">Prepaid <a href="#" data-bs-toggle="popover"  data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Payment already received from the Buyer" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></label>
                                    </div>
                                </div>
                                <div class="col-12 col-md mb-3">
                                  <div class="form-check form-check-inline">
                                  <input class="form-check-input"  type="radio" name="cod" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)}  checked={paymentmode.mode==2} />
                                <label class="form-check-label" for="inlineRadio1">COD (Cash On Delivery) <a href="#" data-bs-toggle="popover"  data-bs-placement="top" data-bs-trigger="hover" data-bs-content="COD payment will be credited to your account" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></label>
                                  </div>
                                </div>
                            </div>
                            {paymentmode.mode==2?
                        <div class="row">
                          <div class="col-12 col-md-5 mb-3">
                            <input type="text" class="form-control" id="" placeholder="Enter COD amount" name="cod_amount" onChange={(e)=>codvalueChange(e)} value={codvalue.cod_amount} />
                          </div>
                      </div>
                      :""}
                          </section>
                          <hr/>
                          {carriertype.type==1?
                          <section class="pb-3">
                              <h6 class="">Product Details</h6>
                                 {shipstate.map((sub,index)=>(
                              <div class="row g-1">
                                
                                  <div class="col-12 col-md-4 mb-3">
                                  <label for="" class="form-label">Product {index+1} Name:</label>
                                <input type="text" class="form-control" id="" placeholder="Enter your product name" name="shipment_content" onChange={(e) => handleChange3(e,index)} value={sub.shipment_content} />
                                {(sub.error.shipment_content)?
                               <>
                               <i class="fa fa-exclamation-triangle" style={{color:"rgb(167, 37, 20)"}} aria-hidden="true"></i><small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>Product Name is required</small></>:""}  
                            </div>

                                 
                                  <div class="col-12 col-md-2 mb-3">
                                  <label for="" class="form-label">Unit Price:</label>
                                <div class="input-group">
                                    <span class="input-group-text">&#8377;</span>
                                    <input type="number" class="form-control" placeholder="Price"  name="total_value" onChange={(e) => handleChange3(e,index)} value={sub.total_value}/>
                                </div>
                                {(sub.error.total_value)?
                               <>
                               <i class="fa fa-exclamation-triangle" style={{color:"rgb(167, 37, 20)"}} aria-hidden="true"></i><small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>Unit Price is required</small></>:""}
                            </div>

                                  <div class="col-12 col-md-2 mb-3">
                                  <label for="" class="form-label">Quantity:</label>
                                <input type="number" class="form-control" id="" placeholder="Quantity" name="quantity" onChange={(e) => handleChange3(e,index)} value={sub.quantity}/>
                                {(sub.error.quantity)?
                               <>
                               <i class="fa fa-exclamation-triangle" style={{color:"rgb(167, 37, 20)"}} aria-hidden="true"></i><small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>Quantity is required</small></>:""}
                            </div>

                            <div class="col-12 col-md-2 mb-3">
                                  <label for="" class="form-label">SKU:</label>
                                <input type="text" class="form-control" id="" placeholder="Enter sku" name="sku" onChange={(e) => handleChange3(e,index)} value={sub.sku}/>
                               
                            </div>
                                  <div class="col-12 col-md-2 mb-3">
                                    <div class=" add_btns">
                                    {(sub.buttonType == "add") ?
                            //    <a href="#" class="btn btn-primary btn-xs"><i class="material-icons-outlined">add</i></a>
                                <a  class="btn btn-primary btn-xs"><i class="material-icons-outlined" onClick={() => addRows(1)} style={{ cursor: "pointer" }}>add</i></a>:
                                <a  class="btn btn-primary btn-xs"><i class="material-icons-outlined" onClick={() => addRows(2, index)} style={{ cursor: "pointer"}}>remove</i></a>
                                
                                  }
                                    </div>
                                  </div>
                              </div>
                              ))}
                          </section>
                          :
                          <>
                          <div class="row mb-3">
                          <div class="col-12 col-md-4">
                          <label for="" class="form-label">Number of Boxes:</label>
                          <input
      type="number"
      className="form-control"
      id="numberOfBoxes"
      placeholder="Enter number of boxes"
      value={numberOfBoxes}
      onChange={handleNumberOfBoxesChange}
  />
                          </div>
                      </div>
                      {boxDetails.map((box, index) => (
                    <div class="card mb-2" key={index} >
                      <div class="card-body">
                        <section class="">
                          <h6 class="mb-4">Box {index+1} Detail</h6>
                          <div class="row">
                            <div class="col-12 col-md-3 mb-3">
                                <label for="" class="form-label">Box Name:</label>
                                <select className="form-select form-select-sm" onChange={(e) => handleBoxChange(e, index)} defaultValue={box.box_name}>
                      <option value="">Select Box</option>
                      {boxstate.map((sub) => (
                        <option key={sub.box_name} value={sub.box_name}>{sub.box_name}</option>
                      ))}
                    </select>
                    <span>{boxErrors[index]?.box_name}</span>
                            </div>
                            <div class="col-12 col-md-3">
                                  <label for="" class="form-label">Box Dimensions (CM):</label>
                                  <div class="row g-1">
                                    <div class="col-12 col-md mb-3">
                                    <input type="number" className="form-control" id="" placeholder="L"  value={box.box_length} onChange={(e) => handleBoxDimensionChange(e, 'box_length', index)} />
                                    <span>{boxErrors[index]?.box_length}</span>
                                    </div>
                                    <div class="col-12 col-md mb-3">
                                      <input type="number" class="form-control" id="" placeholder="W" name=""  value={box.box_width} onChange={(e) => handleBoxDimensionChange(e, 'box_width', index)}/>
                                      <span>{boxErrors[index]?.box_width}</span>
                                    </div>
                                    <div class="col-12 col-md mb-3">
                                      <input type="number" class="form-control" id="" placeholder="H" name=""  value={box.box_height} onChange={(e) => handleBoxDimensionChange(e, 'box_height', index)}/>
                                      <span>{boxErrors[index]?.box_height}</span>
                                    </div>
                                  </div>
                            </div>
                            <div class="col-12 col-md-3">
                              <label for="" class="form-label">Box Weight(KG):</label>
                              <input type="number" class="form-control" id="" placeholder="Weight" name=""  value={box.box_weight} onChange={(e) => handleBoxDimensionChange(e, 'box_weight', index)}/>
                              <span>{boxErrors[index]?.box_weight}</span>
                            </div>
                            <div class="col-12 col-md-2">
                              <label for="" class="form-label">Box Quantity:</label>
                              <input type="number" class="form-control" id="" placeholder="Quantity" name="" value={box.quantity} onChange={(e) => handleBoxDimensionChange(e, 'quantity', index)}/>
                              <span>{boxErrors[index]?.quantity}</span>
                            </div>
                          </div>
                        </section>
                        <section class="pb-3">
                          <div class="row">
                              <div class="col-12 col-md-4 mb-3">
                                  <label for="" class="form-label">Product Name:</label>
                                  <input type="text" class="form-control" id="" placeholder="Enter your product name" value={box.product_name} onChange={(e) => handleBoxDimensionChange(e, 'product_name', index)}/>
                              <span>{boxErrors[index]?.product_name}</span>

                              </div>
                              <div class="col-12 col-md-3 mb-3">
                                <label for="" class="form-label">Unit Price:</label>
                                  <div class="input-group">
                                      <span class="input-group-text">&#8377;</span>
                                      <input type="number" class="form-control" placeholder="Enter Price" value={box.unit_price} onChange={(e) => handleBoxDimensionChange(e, 'unit_price', index)}/>
                                  </div>
                                  <span>{boxErrors[index]?.unit_price}</span>
                              </div>
                            
                             
                          </div>
                        </section>
                      </div>
                    </div>
                      ))}
                      </>
                      
                          }
                          <hr/>
                          {carriertype.type==2?
                          <>
                    <div class="row mb-3">
                        <div class="col-12 col-md-4">
                        <label for="" class="form-label">Number of Invoics:</label>
                          <select class="form-select form-select-sm"onChange={handleNumberOfInvoicesChange} value={numberOfInvoices}>
                          {[...Array(10).keys()].map((num) => (
            <option key={num + 1} value={num + 1}>{num + 1}</option>
          ))} 
                          
                          </select>
                        </div>
                    </div>
                    <div class="card">
                    {invoiceDetails.map((invoice, index) => (
                      <div class="card-body" key={index}>
                      <h6>Invoice {index+1}</h6>
                    <div class="row">
                        <div class="col-12 col-md">
                          <label for="" class="form-label">Invoice Number:</label>
                          <input type="text" class="form-control" id="text" placeholder="Invoice Number" onChange={(e) => handleInvoiceDimensionChange(e, 'invoice_number', index)}/>
                          <span>{invoiceErrors[index]?.invoice_number}</span>
                        </div>
                        <div class="col-12 col-md">
                          <label for="" class="form-label">Invoice Date:</label>
                          <input type="date" class="form-control" id="text" placeholder="Invoice Date" onChange={(e) => handleInvoiceDimensionChange(e, 'invoice_date', index)}/>
                          <span>{invoiceErrors[index]?.invoice_date}</span>
                        </div>
                        <div class="col-12 col-md">
                          <label for="" class="form-label">Invoice Amount:</label>
                          <input type="text" class="form-control" id="text" placeholder="Invoice Amount" onChange={(e) => handleInvoiceDimensionChange(e, 'invoice_amount', index)}/>
                          <span>{invoiceErrors[index]?.invoice_amount}</span>
                        </div>
                        <div class="col-12 col-md">
                          <label for="" class="form-label">EBN Number:</label>
                          <input type="text" class="form-control" id="text" placeholder="Invoice EBN Number" onChange={(e) => handleInvoiceDimensionChange(e, 'invoice_ebn', index)}/>
                          <span>{invoiceErrors[index]?.invoice_ebn}</span>
                        </div>
                      
                    </div>
                
                      </div>
                    ))}
                    </div> 
                    </>:
                  ""
                    }
                        
                        {carriertype.type==1?
                          <div class="card border-0 bg-light">
                            <div class="card-body">
                              {/* <div class="d-flex justify-content-between pb-2">
                                  <div class="">
                                    Sub-total for Product
                                  </div>
                                  <div class="">Rs. 0</div>
                              </div> */}
                              {/* <div class="d-flex justify-content-between pb-4">
                                <div class="">
                                  Other Charges
                                </div>
                                <div class="">Rs. 0</div>
                              </div> */}
                              <div class="d-flex justify-content-between">
                                <div class="">
                                  <h5>Total Order Value</h5>
                                </div>
                                <div class=""><h5>Rs.{totalValue} </h5></div>
                              </div>
                            </div>
                          </div>
                          :
                          <>
                          <hr/>
                          <h6 class="mb-1">Insurance</h6>
                          <small class="">Select insurance for the order</small>
                          <div class="row mt-4">
                              <div class="col-12 col-md-3 mb-3">
                                  <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="owner_risk" id="inlineRadio1" value="option1" onChange={(e) => risk_mode(e)} checked={riskstate.risk==1}/>
                                    <label class="form-check-label" for="inlineRadio1">OR (Owner Risk) <a href="#" data-bs-toggle="popover"  data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Insurance charges will not apply to this order" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></label>
                                  </div>
                              </div>
                              <div class="col-12 col-md mb-3">
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" name="carrier_risk" id="inlineRadio1" value="option1" onChange={(e) => risk_mode(e)} checked={riskstate.risk==2} />
                                  <label class="form-check-label" for="inlineRadio1">CR (Carrier Risk) <a href="#" data-bs-toggle="popover"  data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Insurance charges will be applied to this order." class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></label>
                                </div>
                              </div>
                          </div>
                          </>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="card mb-3">
                        <div class="card-body">
                          <section class="pb-3">
                            <div class="row">
                                <div class="col-12 col-md-12 mb-3">
                                    <label for="" class="form-label">Order ID: <small class="text-muted">(Leave Blank for Auto Generate)</small></label>
                                    {parsed.order_id==""?
                                <input type="text" class="form-control" id="" placeholder="Order ID" value ={statetype.order_number} name="order_number" onChange={(e)=>handleChangetype(e)}  />
                                :  <input type="text" class="form-control" id="" placeholder="Order ID" value ={statetype.order_number} name="order_number" onChange={(e)=>handleChangetype(e)}  />}
                                </div>
                                <div class="col-12 col-md-12 mb-3">
                                    <label for="" class="form-label">Order Date: <small class="text-muted">(Leave Blank for Auto Generate)</small></label>
                                    <input type="date" class="form-control" id="" placeholder="Enter Full Name" value={statetype.order_date} name="order_date" onChange={(e)=>handleChangetype(e)} />
                                </div>
                                {/* <a data-bs-toggle="collapse" data-bs-target="#show_smgt" class="text-primary">Show advance options</a> */}

                                {/* <div id="show_smgt" class="collapse">
                                  <div class="col-12 col-md-12 mb-3">
                                    <label for="" class="form-label">Sales Channel:</label>
                                    <select class="form-select form-select-sm">
                                      <option>Direct Sales</option>
                                      <option>Shopify</option>
                                      <option>Woocommerce</option>
                                      <option>Flipkart</option>
                                      <option>Other</option>
                                    </select>
                                  </div>
                                  <div class="col-12 col-md-12 mb-3">
                                      <label for="" class="form-label">Seller Note:</label>
                                      <textarea class="form-control" rows="2" id="comment" name="text" placeholder="Enter details"></textarea>
                                  </div>
                                </div> */}
                            </div>
                        </section>
                        </div>
                      </div>
                      {carriertype.type==1?
                      <div class="card  mb-3 ">
                        <div class="card-body">
                          {/* <section class="pb-3">
                              <h6 class="">Box Type</h6>
                              <div class="row">
                                  <div class="col-12 col-md-12 mb-3">
                                      <select class="form-select form-select-sm">
                                        <option>Custom Box</option>
                                        <option>Small Box 1 (10 x 10 x 10 cm) - 10kg</option>
                                        <option>3</option>
                                        <option>4</option>
                                      </select>
                                  </div>
                              </div>
                          </section> */}
                          <section class="pb-3">
                              <h6 class="">Dead Weight <a href="#" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Dead Weight is the physical weight" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></h6>
                              <div class="row">
                                  <div class="col-12 col-md-12 mb-3">
                                  <div class="input-group">
                                  <input  type="text"
  className="form-control"
  placeholder="Your shipment weight"
  name="dead_weight"
  value={deadstate.dead_weight}
  onChange={(e) => handleWeightChange(e)}
   />
                                  <span class="input-group-text">KG</span>
                                </div>
                                {error?<>
                            <small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>{error}</small></>:""}
                                      {/* <small class="text-muted">
                                        (Max. 3 digits after decimal place) <br/> Note: The minimum chargeable weight is 0.50 Kg
                                      </small> */}
                                  </div>
                              </div>
                          </section>
                          <hr/>
                          <section class="pb-3">
                            <h6 class="">Volumetric Weight <a href="#" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Volumetric Weight is calcuated by LxHxW/Range" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></h6>
                            <small>Enter packages dimensions to calculate Volumetric Weight</small>
                            <div class="row pt-3">
                                <div class="col-12 col-md-12 mb-3">
                                    <div class="row g-1">
                                        <div class="col-12 col-md-4 mb-3">
                                          <label for="" class="form-label">Height:</label>
                                          <div class="input-group">
                                      <input type="number" class="form-control" placeholder="H" name="height" onChange={(e) => handleInputChange(e)} value={dimestate.height}/>
                                      <span class="input-group-text">CM</span>
                                    </div>
                                    {errorHeight?<>
                            <small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>{errorHeight}</small></>:""}
                                        </div>
                                        <div class="col-12 col-md-4 mb-3">
                                          <label for="" class="form-label">Width:</label>
                                          <div class="input-group">
                                      <input type="number" class="form-control" placeholder="W" name="width" onChange={(e) => handleInputChange(e)}   value={dimestate.width}/>
                                      <span class="input-group-text">CM</span>
                                    </div>
                                    {errorWidth?<>
                            <small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>{errorWidth}</small></>:""}
                                        </div>
                                        <div class="col-12 col-md-4 mb-3">
                                          <label for="" class="form-label">Length:</label>
                                          <div class="input-group">
                                      <input type="number" class="form-control" placeholder="L" name="length" onChange={(e) => handleInputChange(e)}  value={dimestate.length}  />
                                      <span class="input-group-text">CM</span>
                                    </div>
                                    {errorLength?<>
                            <small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>{errorLength}</small></>:""}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 mb-3">
                                  
                                </div>
                            </div>
                            <div class="card border-0 bg-light">
                              <div class="card-body">
                                <h6>Volumetric Weight <span class="ms-5">{volume} Kg</span></h6>
                              </div>
                            </div>
                          </section>
                          <hr/>
                          <section>
                            <div class="card border-0 bg-light py-3">
                              <div class="card-body">
                                <h5 class="mb-3">Applicable Weight <span class="ms-5">{volume && deadstate.dead_weight !== "" ? 
      (parseFloat(volume) > parseFloat(deadstate.dead_weight) ? volume : deadstate.dead_weight) + " Kg" :
      "0.00 Kg"
    }</span></h5>
                                <small class="text-muted">*Applicable weight is the heavier among the two weights that is Dead Weight V/s the Volumetric Weight, basis on which freight charges are calculated.<br/>
                                  *Final chargeable weight will be based on the weight slab of the courier selected before shipping</small>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                      :""}
                      {addbutton==false?
                  <a onClick={()=>orderCreate()} class="btn btn-primary">Create Order</a>
                  :""}
                    </div>
                </div>
                
                
                
                
              </section>
                  

     
          </div>
        </section>
        
    </section>
    <Footer
                    showProgressBar={showProgressBar}
                    completedOrders={completedOrders}
                    totalOrders={totalOrders}
                    viewLogs={recordId}
                    status ={status}
                     toggleProgressBar={toggleProgressBar} 
                     showorderBar={showorderBar}
                     completedOrdersbulk={completedOrdersbulk}
                     totalOrdersbulk={totalOrdersbulk}
                     viewLogslogid={logidstate}
                     statusbulk ={statusstateorder}
                      toggleProgressBarbulk={toggleProgressBarbulk} 
                  />

   
    </div>
  )
}

export default Create_order
